import React from 'react';

import { CA } from 'contexts';
import * as Form from 'components/form';

export function RankingTermForm(props) {
    const { state } = React.useContext(CA);
    const { user } = state;
    const { form, onSubmit } = props;

    // Create form fields object
    const fields = {
        accept: {
            error: form.errors.accept,
            label: props.t('glossary:acceptTermRanking'),
            name: 'accept',
            type: 'checkbox',
            value: form.values.accept,
            onChange: form.handleChange,
        },
        acceptPrivacyTerms: {
            error: form.errors.acceptPrivacyTerms,
            label: props.t('glossary:acceptPrivacyTerms'),
            name: 'acceptPrivacyTerms',
            required: true,
            type: 'checkbox',
            value: form.values.acceptPrivacyTerms,
            onChange: form.handleChange,
        },
    };

    // Handle form submition
    const evSubmit = ev => form.handleSubmit(ev, onSubmit);
    return (
        <Form.Form name="RankingTermForm" onSubmit={evSubmit}>
            <Form.Field {...fields.accept} />
            {user.userStatus === 'none' && <Form.Field {...fields.acceptPrivacyTerms} />}
            <Form.Submt {...form} text={props.t('glossary:continue')} />
        </Form.Form>
    );
}
export default RankingTermForm;
